package com.mps.asc_app.ui.screens

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp

@Composable
fun EmailNotVerifiedScreen(
    modifier: Modifier = Modifier,
    onRefresh: (() -> Unit)? = null,
    onLogout: (() -> Unit)? = null,
    onResendEmail: (() -> Unit)? = null,
    isResending: Boolean = false,
    resendSuccess: Boolean = false,
    resendError: String? = null,
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .padding(24.dp),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Text(
            text = "Bitte bestaetige zuerst deine E-Mail-Adresse.",
            style = MaterialTheme.typography.headlineSmall,
            textAlign = TextAlign.Center
        )

        Spacer(Modifier.height(12.dp))

        Text(
            text = "Wir haben dir eine Verifizierungs-Mail gesendet. Bitte oeffne dein Postfach und bestaetige die E-Mail-Adresse. Danach kannst du hier auf Aktualisieren tippen.",
            style = MaterialTheme.typography.bodyMedium,
            textAlign = TextAlign.Center
        )

        Spacer(Modifier.height(24.dp))

        if (onResendEmail != null) {
            if (isResending) {
                CircularProgressIndicator(modifier = Modifier.size(36.dp))
            } else {
                OutlinedButton(onClick = onResendEmail) {
                    Text("E-Mail erneut senden")
                }
            }

            Spacer(Modifier.height(8.dp))

            if (resendSuccess) {
                Text(
                    text = "✅ Verifizierungs-Mail wurde erneut gesendet.",
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.primary,
                    textAlign = TextAlign.Center
                )
            }

            resendError?.let {
                Text(
                    text = it,
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.error,
                    textAlign = TextAlign.Center
                )
            }

            Spacer(Modifier.height(16.dp))
        }

        if (onRefresh != null) {
            Button(onClick = onRefresh) {
                Text("Aktualisieren")
            }
        }

        if (onRefresh != null && onLogout != null) {
            Spacer(Modifier.height(12.dp))
        }

        if (onLogout != null) {
            Button(onClick = onLogout) {
                Text("Abmelden")
            }
        }
    }
}
